import axios from 'axios'
import nprogress from 'nprogress'
import 'nprogress/nprogress.css'

// 创建一个axios实例（复制出一个新的axios）
const request = axios.create({
  baseURL:'http://www.0313.com',//基本路径
  timeout:5000, //超时时间
})


// 请求拦截器
request.interceptors.request.use((config)=>{
  //在请求头加入一个a字段，值为100，此处我们添加的是a，只是为了做测试，后期会添加一个很厉害的东西—— token
  config.headers.a = 100
  // 进度条开始走
  nprogress.start()
  // 将本次请求的详细配置信息返回，若不返回会造成所有请求配置的丢失，最终走的是失败的回调（例子：地铁安检站）
  return config
})

// 响应拦截器
request.interceptors.response.use(
  // 响应拦截器成功的回调
  response => {
    // 进度条停止
    nprogress.done()
    // 将服务器返回的真正数据，交给request的使用者
    return response.data
  },
  error => {
    // 弹窗展示失败的原因
    alert(error.message)
    // 进度条停止
    nprogress.done()

    // 第一种做法：将错误继续传递下去
    // return Promise.reject(error.message)

    // 第二种做法：让整体流程结束
    return new Promise(()=>{})
  }
)

export default request